/**
 * Tipos de configuracion de asistencia — Define metodos, ubicacion y reglas anti-fraude
 *
 * Que hace: Define los tipos para la configuracion del sistema de asistencia multi-metodo
 * Que exporta: AttendanceMethod, BusinessLocation, AttendanceConfig, defaults
 * Que NO debe hacer: Logica de negocio o llamadas a API
 */

export type AttendanceMethod = "qr" | "facial" | "carnet";
export type LateAction = "advertir" | "acumular" | "descontar";

export interface LatePolicy {
  toleranciaMinutos: 0 | 5 | 10 | 15 | 30;
  accion: LateAction;
}

export interface BusinessLocation {
  /** Latitud GPS del local */
  lat: number;
  /** Longitud GPS del local */
  lng: number;
  /** Radio permitido en metros (50, 100, 200, 500) */
  radio: number;
  /** Direccion legible (opcional, solo informativa) */
  direccion?: string;
  /** Ciudad (opcional, solo informativa) */
  ciudad?: string;
  /** Fecha en que se establecio la ubicacion */
  setAt: string;
  /** Fuente de la ubicacion (gps automatico, link maps, manual) */
  fuente: "gps" | "maps_url" | "manual";
}

export interface AttendanceConfig {
  /** Metodos habilitados por el dueno (minimo 1) */
  metodosHabilitados: AttendanceMethod[];
  /** Si el GPS es obligatorio para validar asistencia */
  gpsObligatorio: boolean;
  /** Ubicacion del negocio (null si aun no se ha configurado) */
  ubicacionNegocio: BusinessLocation | null;
  /** Semilla secreta para generar el QR diario (se genera 1 vez por negocio) */
  qrSecretSeed: string;
  /** Regla aplicada al registrar entradas posteriores al horario del empleado. */
  politicaTardanzas: LatePolicy;
  /** Fecha de ultima actualizacion */
  updatedAt: string;
}

/** Configuracion por defecto cuando un negocio aun no la ha establecido */
export const DEFAULT_ATTENDANCE_CONFIG: AttendanceConfig = {
  metodosHabilitados: ["qr", "facial"],
  gpsObligatorio: false,
  ubicacionNegocio: null,
  qrSecretSeed: "",
  politicaTardanzas: { toleranciaMinutos: 5, accion: "advertir" },
  updatedAt: new Date().toISOString(),
};

export const RADIO_OPTIONS = [
  { value: 50, label: "50 metros (estricto)" },
  { value: 100, label: "100 metros (recomendado)" },
  { value: 200, label: "200 metros (flexible)" },
  { value: 500, label: "500 metros (muy flexible)" },
];
